module.exports = __webpack_public_path__ + "static/marchi-arkalia-bio-19f07f41a0ccd15b789a2ab5cdc1da1f.jpg";